<template>
    <div class="container bg-light">
        <h1 class="bg-warning text-light rounded-pill">Privacy</h1>
        <h3 class="p-2 rounded-pill">TOS informatie over privacy</h3>
        <div class="text-left">
            <div class="card mb-1">
                <div class="card-body">
                    <h5 class="card-title bg-info text-light text-center rounded-pill">Juridische gronden</h5>
                    <h6 class="card-subtitle bg-light text-muted rounded-pill">
                        Wat zijn de ‘juridische gronden’ voor het gebruik van jouw gegevens?</h6>
                    <p class="card-text">
                        Volgens de Twiedaliaanse privacywetgeving moeten we zeggen welke ‘juridische gronden’ we hebben om je gegevens te gebruiken.
                        We hebben gegevens van je nodig vanwege de contractuele afspraken tussen jou en Twiedalia Omroep Stichting (hierna: TOS), zoals bijvoorbeeld het door jou bekijken van een pagina.
                        Dit is het geval bij:</p>
                    <ul>
                        <li>Browsen op de Twiedalia website</li>
                        <li>Schrijven van ingezonden brieven</li>
                        <li>Bezorging van de fysieke krant</li>
                    </ul>
                    Daarnaast kunnen we je gegevens gebruiken bij ‘gerechtvaardigd belang’. Dat betekent dat we alle Digibirds de meest optimale, persoonlijke service willen verlenen.
                    Hierbij denken we altijd aan jouw privacy. Dit geldt voor:
                    <br>
                    <br>
                    <ul>
                        <li>Reviews & ingezonden brieven</li>
                        <li>Contact met onze digibirdservice</li>
                        <li>Bezoek van de TOS-website</li>
                        <li>Account op de TOS-websites</li>
                        <li>Nieuwsbrief & e-mail</li>
                        <li>Persoonlijk advies</li>
                        <li>Acties</li>
                        <li>Social media</li>
                    </ul>
                    We kunnen ook een wettelijke verplichting hebben om je gegevens te gebruiken, bijvoorbeeld wanneer we fraude vermoeden.
                    En soms heb je ons zelf toestemming gegeven om je gegevens te gebruiken, zoals wanneer je je aanmeldt voor de nieuwsbrief. Dit houden we netjes bij.
                </div>
            </div>

            <div class="card mb-1">
                <div class="card-body">
                    <h5 class="card-title bg-info text-light text-center rounded-pill">Gegevenstoegang</h5>
                    <h6 class="card-subtitle bg-light text-muted rounded-pill">Wie heeft toegang tot jouw gegevens?</h6>
                    <p class="card-text">
                        We geven je gegevens alleen door aan andere partijen als dat echt nodig is voor onze dienstverlening.
                        Het betreft dan deze partijen: De Twiedaliaanse bezorgkoeriers, Twiedalia reparaties B.V., Twiedaliaanse handelspartners en Twiedalia media B.V. Onze bezorgpartner moet tenslotte je bestelling afleveren op het juiste nest en het is fijn als een reparateur bij je eigen nest langskomt om je koelkast te maken en niet per ongeluk bij het nest van de buren met een werkende koelkast op de tak staat.
                        In verdachte situaties zijn we verplicht om klantgegevens te delen met de Twiedaliaanse overheidsinstantie.
                    </p>
                    De partijen die van ons toegang krijgen tot je gegevens, mogen deze alleen gebruiken om jou een dienst te leveren namens TOS, tenzij ze zelf verantwoordelijk zijn voor het verkrijgen en beschermen van je gegevens. Sommige cookie-ontwikkelaars hebben toegang tot de gegevens die cookies op onze website verzamelen. Je leest hier meer over in ons cookiestatement en het privacybeleid van deze partijen. We verkopen jouw gegevens nooit aan andere Digibirds.
                </div>
            </div>

            <div class="card mb-1">
                <div class="card-body">
                    <h5 class="card-title bg-info text-light text-center rounded-pill">Gegevensopslag</h5>
                    <h6 class="card-subtitle bg-light text-muted rounded-pill">
                        Waar worden jouw gegevens opgeslagen?</h6>
                    <p class="card-text">
                        We geven je gegevens alleen door aan andere partijen als dat echt nodig is voor onze dienstverlening.
                        We slaan je gegevens op in verschillende databases. We hanteren altijd strenge beveiligingsmaatregelen. Oost west, eigen nest best: daarom worden je gegevens bijna altijd opgeslagen binnen de Twiedaliaanse Nesten Unie (TNU). In het uitzonderlijke geval dat klantgegevens worden doorgegeven naar nestgebieden buiten Twiedalia, zorgen we ervoor dat jouw privacy op een passende manier beschermd blijft.
                        Voor een aantal nestgebieden is dit officieel vastgesteld.</p>
                    Sommige partijen buiten Twiedalia hebben zich geregistreerd onder de Privacy Boom dat voldoende bescherming biedt.
                    Of we werken met officiële modelcontracten die speciaal zijn opgesteld om jouw privacy te waarborgen.
                </div>
            </div>

            <div class="card mb-1">
                <div class="card-body">
                    <h5 class="card-title bg-info text-light text-center rounded-pill">Bewaartermijn</h5>
                    <h6 class="card-subtitle bg-light text-muted rounded-pill">Hoe lang bewaren we jouw gegevens?</h6>
                    <p class="card-text">
                        We bewaren en gebruiken jouw gegevens niet langer dan noodzakelijk. Daarna verwijderen we alle data die we van je hebben.
                        Of gebruiken we jouw gegevens anoniem, omdat we bepaalde data nodig hebben voor interne analyses en rapportages zoals de waarde van je bestelling.
                    </p>
                    Klinkt lekker simpel, maar hoe werkt dat in de praktijk? We houden bepaalde termijnen aan, waarna we je gegevens verwijderen. Dit zijn ze:
                    <br/>
                    Inactieve digibirdaccounts verwijderen we na 7 jaar. Na die periode gebruiken we je gegevens alleen anoniem, voor interne rapportages.
                    Van de Twiedaliaanse Belastingdienst moeten we onze administratie met jouw factuur-, betaal- en bestelgegevens 7 jaar bewaren.
                    Daarna gebruiken we alleen anonieme gegevens voor interne rapportages. Je moet zelf ook de facturen van je aankopen goed bewaren, voor wanneer bijvoorbeeld je garantie verloopt.
                    Gegevens die we gebruiken om fraude te voorkomen bewaren we heel lang. Niet leuk, wel nodig.
                </div>
            </div>

            <div class="card mb-1">
                <div class="card-body">
                    <h5 class="card-title bg-info text-light text-center rounded-pill">Rechten</h5>
                    <h6 class="card-subtitle bg-light text-muted rounded-pill">Wat zijn jouw rechten?</h6>
                    <p class="card-text">Uiteraard blijf jij de baas over jouw gegevens.
                    </p>
                    Uitschrijven voor de nieuwsbrief is zo gepiept. Dat doe je in je 'Mijn Digibird'-account of via de link onderaan de nieuwsbrief zelf. En wil je helemaal geen cookies meer?
                    Ook dat kan je zelf regelen. Lees in ons cookiestatement hoe je dat doet.
                    <br/>
                    We willen zeker weten dat jij écht de Digibird bent die je zegt dat jij bent. Daarom kunnen we aanvullende informatie van je vragen om je identiteit vast te stellen. Dat doen we ook bij onduidelijke verzoeken.
                </div>
            </div>

            <div class="card mb-1">
                <div class="card-body">
                    <h5 class="card-title bg-info text-light text-center rounded-pill">Vraag- en klachtafhandeling</h5>
                    <h6 class="card-subtitle bg-light text-muted rounded-pill">Heb je vragen of klachten?</h6>
                    <p class="card-text">
                        Voor vragen of klachten over je gegevens en de bescherming van je privacy kan je contact opnemen met de Data Protection Officer van TOS.
                    </p>
                    <h5>Mailen: privacyvragen@twiedalia.nl</h5>
                    <h5>Schrijven: Hoofdstraat 2, 1AA Twiedalia, t.a.v. Digibird <strike>Piet</strike>&nbsp;
                        <small>(Naam gecensureerd vanwege privacyredenen)</small>.
                    </h5>
                    <br/>
                    Wanneer je niet tevreden bent over hoe TOS omgaat met jouw privacy kan je contact opnemen met de Digibird privacy-autoriteit.
                </div>
            </div>

            <div class="card mb-1">
                <div class="card-body">
                    <h5 class="card-title bg-info text-light text-center rounded-pill">Verantwoording</h5>
                    <h6 class="card-subtitle bg-light text-muted rounded-pill">
                        Wie is verantwoordelijk voor jouw gegevens?</h6>
                    <p class="card-text">
                        Voor vragen of klachten over je gegevens en de bescherming van je privacy kan je contact opnemen met de Data Protection Officer van TOS.
                    <h4>Wij zijn TOS B.V.</h4>
                    <br/>
                    Je kunt ons zo bereiken:
                    <h5>Bellen: 17</h5>
                    <h5>Mailen: privacy@twiedalia.nl</h5>
                    <h5>Binnenvliegen: Hoofdstraat 2, 1AA Twiedalia</h5>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'privacy'
    }
</script>
<style scoped>
    h3 {
        background-color: lightblue;
    }
</style>
